import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { AemConfigurationThirdpartySocialLoginProvider } from '@as-react/common-types';
import { Button, ButtonVariant, ButtonState, Column, IconName, Link, Row, Text } from '@as/cotopaxi';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import FormValidationUtil from '../../../util/FormValidationUtil';
import { ScrollUtil } from '../../../util/ScrollUtil';
import { getLoginError } from '../../../util/LoginUtil';
import { CookieUtil } from '@as-react/common-utils';
import { LoginForm } from '../../login-form/LoginForm';
export const Login = ({ login, facebook, registrationLink, socialLogin, onAuthResetForm, onEmailChange, cookieConsentSettingAvailable, }) => {
    const { socialEnabledList } = useAemConfig();
    const { t } = useTranslation([
        I18N_NAMESPACES.account,
        I18N_NAMESPACES.checkout,
        I18N_NAMESPACES.general,
        I18N_NAMESPACES.navigation,
    ]);
    const [shouldRenderSocial, setShouldRenderSocial] = useState(cookieConsentSettingAvailable);
    useEffect(() => {
        setShouldRenderSocial(cookieConsentSettingAvailable || CookieUtil.isCookieLevelAcceptAll());
        onAuthResetForm();
    }, []);
    const handleValidation = (values) => {
        const errors = {};
        if (!values.email) {
            errors.email = t(`${I18N_NAMESPACES.account}:delivery.required`);
        }
        else if (!FormValidationUtil.isValidEmailPattern(values.email)) {
            errors.email = t(`${I18N_NAMESPACES.general}:email.error.invalid`);
        }
        if (!values.password) {
            errors.password = t(`${I18N_NAMESPACES.account}:delivery.required`);
        }
        return errors;
    };
    const onErrorHandler = (errors) => {
        ScrollUtil.scrollToErrorElement(document.querySelector(`[for="${errors[0]}"]`), true);
    };
    const handleSocialLoginFacebook = () => {
        socialLogin(AemConfigurationThirdpartySocialLoginProvider.FACEBOOK);
    };
    return (_jsxs("div", { "data-analytics-bannerid": "header-account-login", children: [_jsx(Row, { clear: true, children: _jsx(Column, { gutter: false, gutterBottom: true, children: _jsx(LoginForm, { onSubmit: login.onSubmit, action: login.action, forgotPasswordClicked: login.forgotPasswordClicked, errorFeedback: getLoginError(login.errorFeedback, t), validate: handleValidation, onEmailChange: onEmailChange, onSubmitError: onErrorHandler, initialEmail: login.initialEmail, loading: login.loading }) }) }), shouldRenderSocial && socialEnabledList.includes(AemConfigurationThirdpartySocialLoginProvider.FACEBOOK) && (_jsx(Row, { clear: true, children: _jsx(Column, { gutter: false, gutterBottom: true, gutterTop: true, children: _jsx(Button, { fill: true, onClick: handleSocialLoginFacebook, variant: ButtonVariant.FACEBOOK, state: facebook.loading ? ButtonState.LOADING : undefined, text: t(`${I18N_NAMESPACES.account}:account.social.media.login`, {
                            platform: 'Facebook',
                        }), iconLeft: { name: IconName.FACEBOOK_BOX } }) }) })), registrationLink && (_jsx(Row, { clear: true, children: _jsxs(Column, { gutter: false, gutterBottom: true, gutterTop: true, children: [_jsxs(Text, { inline: true, emphasized: true, children: [t(`${I18N_NAMESPACES.account}:account.navigation.registration.cta.text`), ' '] }), _jsx(Link, { href: registrationLink, dataQA: "register_link", children: t(`${I18N_NAMESPACES.account}:account.navigation.registration.cta.link`) })] }) }))] }));
};
